module.exports = function($scope) {
  var vm = this;

  $scope.init = function () {
    $scope.text = $scope.ngDialogData.text;
  }

  $scope.ok = function () {
    $scope.closeThisDialog({action:"ok"})
  }

  $scope.cancel = function () {
    $scope.closeThisDialog({action:"cancel"});
  }

  $scope.init();
}
